import React from 'react';
import { DownloadCloud, Sparkles } from 'lucide-react';
import Features from '../components/Features';
import Background from '../components/Background';

export default function Home() {
  return (
    <>
      <Background />
      <div className="min-h-screen flex flex-col relative">
        <div className="flex-1 container mx-auto px-4 py-16">
          <div className="text-center mb-24 animate-fadeIn">
            <div className="relative inline-block">
              <div className="absolute -inset-1 bg-purple-500/20 rounded-[30px] blur-xl animate-pulse" />
              <h1 className="relative text-7xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-purple-600">
                Synapse X Remake
              </h1>
            </div>
            <div className="flex items-center justify-center gap-2 text-xl text-gray-300 mt-6 animate-slideUp">
              <Sparkles className="w-5 h-5 text-purple-400 animate-pulse" />
              <p>The Most Powerful Script Utility</p>
              <Sparkles className="w-5 h-5 text-purple-400 animate-pulse" />
            </div>
          </div>

          <Features />

          <div className="flex justify-center animate-fadeIn" style={{ animationDelay: '0.6s' }}>
            <a
              href="https://github.com/ForlornWindow46/SynapseXRemake/releases/download/synx/SynXRemake.zip"
              className="relative group"
            >
              <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-purple-900 rounded-lg blur transition-all group-hover:blur-md" />
              <div className="relative bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white px-8 py-4 rounded-lg flex items-center gap-3 transition transform hover:scale-105">
                <DownloadCloud className="w-6 h-6" />
                Download Now
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
